import { Logo } from 'foundations-components/transitional/components/Logo';
import { Image } from 'foundations-components/transitional/components/Image';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { getIsChatSpot, getIsConnect } from 'LoginUI/utils/urls';
// @ts-expect-error not converted to TS
import ImageUrl from 'LoginUI/images/imageUrls';
import { useLocalizedLanguageLinks } from 'LoginUI/hooks/useLocalizedLanguageLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AppLogo({
  children,
  logoWidth = '128px',
  logoAlignment = 'start',
  logoPadding = '1000',
  isMobileLogin = false
}) {
  const isChatSpot = getIsChatSpot();
  const isConnect = getIsConnect();
  const {
    homepageLink
  } = useLocalizedLanguageLinks();
  const renderLogo = () => {
    if (isChatSpot) {
      return /*#__PURE__*/_jsx(Image, {
        src: ImageUrl.chatSpotLogo,
        alt: "ChatSpot Logo",
        inlineSize: logoWidth,
        marginBlockStart: "400"
      });
    } else if (isConnect) {
      return /*#__PURE__*/_jsx(Image, {
        src: ImageUrl.connectLogo,
        inlineSize: logoWidth,
        alt: "Connect Logo",
        marginBlockEnd: "200",
        marginBlockStart: "400"
      });
    } else if (isMobileLogin) {
      return /*#__PURE__*/_jsx(Link, {
        href: homepageLink,
        children: /*#__PURE__*/_jsx(Image, {
          src: ImageUrl.hubspotLogoMobile,
          inlineSize: "38px",
          alt: "Hubspot Logo",
          marginBlock: "0",
          marginInline: "0"
        })
      });
    } else {
      return /*#__PURE__*/_jsx(Link, {
        href: homepageLink,
        children: /*#__PURE__*/_jsx(Logo, {
          name: "hubspot-wordmark",
          width: logoWidth,
          alt: "Hubspot Homepage",
          marginBlockEnd: "200",
          marginBlockStart: "400"
        })
      });
    }
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    padding: logoPadding,
    alignItems: logoAlignment,
    alignSelf: logoAlignment,
    children: [renderLogo(), /*#__PURE__*/_jsx("div", {
      children: children
    })]
  });
}